<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        color="error"
        v-on="on"
      >
        <v-icon>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text> Are you sure you want to delete <b>{{ jobGrade.name }}</b> job grade? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      jobGrade: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.jobGrades().delete(this.jobGrade.id)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })

              this.menu = false
            }
          })
          .catch(error => {
            if (error.response.status >= 400 && error.response.status < 500) {
              this.$snack({ 
                color: 'error',
                message: error.response.data.status, 
              })
            }
          })
          .then(() => {
            this.progressing = false
          })
      },
    },
  }
</script>
